import axios from "axios";
import store from "../redux/store";
import { getClientID, getCommandByIndex, getFilters, getSN, getURL } from "../redux/selectors";

const getBrowserInfo = async (tabID, defaultFilterText) => {
  const state = store.getState();
  const url = getURL(state);
  const clientID = getClientID(state);
  const serialnumber = getSN(state);
  const command = getCommandByIndex(state, tabID);
  const object = `${serialnumber}/object=${command}`;
  const filters = getFilters(state, tabID);
  const searchText = filters?.searchText;
  const filterText = filters?.text ?? "";
  const sort = getFilters(state, tabID)?.sort ?? "";
  const limit = state.settings.app.browserLimit ?? process.env.REACT_APP_GETBROWSERDATA_LIMIT;
  const deviceInfo = state.deviceInfo;
  return await axios
    .post(`${process.env.REACT_APP_BACKEND_DOMAIN}/d1services`, {
      url,
      data: {
        service: "getBrowserInfo",
        clientID,
        object,
        filters: defaultFilterText ?? `${filterText}${searchText && searchText != "" ? `&SEARCH=${searchText}` : ""}`,
        sort,
        version: 2,
        appID: process.env.REACT_APP_SOFTONE_APPID,
        limit,
        // longitude: deviceInfo?.longitude,
        // latitude: deviceInfo?.latitude,
        // deviceId: deviceInfo?.deviceId,
        // deviceName: deviceInfo?.deviceName,
      },
    })
    .then((res) => res.data)
    .catch((er) => ({ success: false, error: er.message }));
};

export default getBrowserInfo;
